import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG, MODAL_md } from '../../../../../../../theme/Component/hooks/useModal';
import { Modal } from '../../../../../../../theme/Component/Modal';
import { BasicTable } from '../../../../../../../theme/Component/BasicTable';
import { OBsEditor } from '../../../../../../../contract/etapa-contrato/contrac/UBLInvoiceSupplier/Component/OBsEditor';
import { AccountEditor } from '../../../../../../../editor/AccountEditor';
import { InputDate } from '../../../../../../../theme/Input/InputDate';
import { _single } from '../../../../../../../../core/services/dataBean/EntityCatalog';
import { BasicButton } from '../../../../../../../theme/Component/BasicButton';
import { _ByDocumentFactory, _ObligationBudget } from '../../../../../../../../core/services/dataBean/EntityCatalogVdos';
import { PrintJson } from '../../../../../../../theme/Component/PrintJson';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
    DocumentFactoryClass?: any;
}

export const AccountantConceptEditor = ({ idSelector, onChange, label, returnType = "ID", render, DocumentFactoryClass }: Props) => {

    const { instance, lista, setLista } = useDataBean(_ByDocumentFactory)
    const [id, setID] = useState(null);
    const [obseditor, setobseditor] = useState<any>({
        IDDocument: NaN,
        DocumentDate: NaN,
    })
    const [account, setaccount] = useState<any>(null)
    const [paymentdate, setpaymentdate] = useState<any>(_single.getCurrenDate())
    const modal = useModal("Cuenta Contable", MODAL_LG);
    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [DocumentFactoryClass])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties.IDAccountantConcept == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getAccountantConceptCatalogByDocumentFactory(DocumentFactoryClass).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp);

                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: 'IDAccountantConcept', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Cuenta Contable"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-12">
                        
                        <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDAccountantConcept); modal.close(); }}></BasicTable>
                    </div>
                </div>



            </Modal>
        </>
    )
}